import USDTFlag from "../../../assets/images/USDT.svg"
import USDCFlag from "../../../assets/images/USDC.svg"

type Props = {
    currency?: string
}

export const EXTENDED_CURRENCY_FLAGS = {
  usdt: USDTFlag,
  usdc: USDCFlag
}

export default function ExtendedCurrencyFlag({ currency }: Props) {
    const currencyCode = currency.toLowerCase()
    const customFlag = EXTENDED_CURRENCY_FLAGS[currencyCode]

    return customFlag ?
        <img src={customFlag} width={24} height={16} /> :
        <span
            className={`currency-flag currency-flag-${currencyCode}`}
        />
}